<template>
    <div>
        <pageHead :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></pageHead>
        <div class="content">
            <div class="search">
                <i-form ref="search" :model="query">
                    <row :gutter="80">
                        <i-col span="6">
                            <form-item label="项目名称" prop="projectName">
                                <Input v-model="query.projectName" clearable />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="印刷编号" prop="printNO">
                                <Input v-model="query.printNO" clearable />
                            </form-item>
                        </i-col>
                        <i-col span="6">
                            <form-item label="状态" prop="status">
                                <Select v-model="query.status">
                                    <Option :value="99">全部</Option>
                                    <Option :value="0">未使用</Option>
                                    <Option :value="1">已使用</Option>
                                </Select>
                            </form-item>
                        </i-col>
                    </row>
                </i-form>
            </div>
            <div class="table-data">
                <i-table :columns="tableHeader" :border="true" :loading="isLoading" :data="tableData" stripe ref="table"
                    @on-selection-change="handleSelect">
                    <template slot-scope="{ row, index }" slot="status">
                        <Tag color="error" v-if="row.status">已使用</Tag>
                        <Tag color="success" v-else>未使用</Tag>
                    </template>
                    <template slot-scope="{ row, index }" slot="action">
                        <Poptip confirm title="确认删除?" placement="left" @on-ok="handleDelete(row.id)">
                            <span class="action">[删除]</span>
                        </Poptip>
                    </template>
                </i-table>
                <div class="page">
                    <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
                </div>
            </div>
        </div>
        <Modal v-model="addModal" title="添加">
            <i-form ref="save" :model="saveObj">
                <row :gutter="80">
                    <i-col span="24">
                        <form-item label="项目名称" prop="projectName">
                            <!-- <Input v-model="query.projectName" clearable placeholder="请输入项目名称" /> -->
                            <Select v-model="saveObj.projectNO" @on-change="projectChange" label-in-value filterable>
                                <Option v-for="item in projects" :value="item.projectNO" :key="item.projectNO">{{
                                        item.projectName
                                }}</Option>
                            </Select>
                        </form-item>
                    </i-col>
                    <i-col span="24">
                        <form-item label="印刷编号" prop="printNO">
                            <Input v-model="saveObj.printNO" clearable placeholder="请输入印刷编号" />
                        </form-item>
                    </i-col>
                </row>
            </i-form>
            <div slot="footer">
                <Button @click="addModal = false">关闭</Button>
                <Button type="primary" :loading="modal_loading" @click="save">保存</Button>
            </div>
        </Modal>
        <Modal v-model="addBatchModal" title="添加">
            <i-form ref="save" :model="saveBatchObj">
                <row :gutter="80">
                    <i-col span="24">
                        <form-item label="项目名称" prop="projectName">
                            <!-- <Input v-model="query.projectName" clearable placeholder="请输入项目名称" /> -->
                            <Select v-model="saveBatchObj.projectNO" @on-change="projectBatchChange" label-in-value filterable>
                                <Option v-for="item in projects" :value="item.projectNO" :key="item.projectNO">{{
                                        item.projectName
                                }}</Option>
                            </Select>
                        </form-item>
                    </i-col>
                    <i-col span="12">
                        <form-item label="起始印刷编号" prop="startPrintNO">
                            <Input v-model="saveBatchObj.startPrintNO" clearable placeholder="请输入印刷编号" />
                        </form-item>
                    </i-col>
                    <i-col span="12">
                        <form-item label="结束印刷编号" prop="endPrintNO">
                            <Input v-model="saveBatchObj.endPrintNO" clearable placeholder="请输入印刷编号" />
                        </form-item>
                    </i-col>
                </row>
            </i-form>
            <div slot="footer">
                <Button @click="addBatchModal = false">关闭</Button>
                <Button type="primary" :loading="modal_loading" @click="saveBatch">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
import miment from "miment";
import qs from 'qs'

const {
    estatePrintList,
    delEstatePrint,
    saveEstatePrint,
    saveBatchEstatePrint,
    estateProjectList,
} = api
export default {
    name: "printNO",
    components: {
        pageHead
    },
    filters: {
        formatData(value) {
            return miment(Number(value)).format("YYYY-MM-DD")
        }
    },
    data() {
        return {
            title: "印刷编号",
            btnList: [{
                name: "重置",
                type: "reset",
            },
            {
                name: "搜索",
                type: "search",
            },
            {
                name: "批量删除",
                type: "delBatch",
            },
            {
                name: "批量添加",
                type: "addBatch",
            },
            {
                name: "添加",
                type: "add",
            }],
            query: {
                projectName: "",
                printNO: "",
                status: 99
            },
            saveObj: {
                projectNO: "",
                projectName: "",
                printNO: "",
                status: 0
            },
            saveBatchObj: {
                projectNO: "",
                projectName: "",
                startPrintNO: "",
                endPrintNO: "",
                status: 0
            },
            tableHeader: [{
                type: "selection",
                width: 70,
                align: "center",
            }, {
                title: "项目编号",
                key: "projectNO",
            }, {
                title: "项目名称",
                key: "projectName",
            }, {
                title: "印刷编号",
                key: "printNO",
            }, {
                title: "状态",
                slot: "status",
            }, {
                title: "操作",
                slot: "action",
                width: 100
            }],
            tableData: [],
            isLoading: false,
            pageNum: 1,
            pageSize: 10,
            total: 0,
            selectedList: [],
            addModal: false,
            addBatchModal: false,
            modal_loading: false,
            projects: []
        }
    },
    methods: {
        handleBtn(type) {
            if (type == "reset") {
                this.pageNum = 1;
                this.$refs.search.resetFields();
                this.query.zlyt = ""
                this.loadData();
            } else if (type == "search") {
                this.pageNum = 1;
                this.loadData();
            } else if (type == "delBatch") {
                if (this.selectedList.length == 0) {
                    return this.$Message.warning("请选择要删除的项目");
                }
                this.$Modal.confirm({
                    title: "删除",
                    content: "是否确认删除",
                    okText: "确认",
                    cancelText: "取消",
                    onOk: () => {
                        this.handleDelete(this.selectedList.join(","));
                    },
                });
            } else if (type == "addBatch") {
                this.addBatchModal = true
            } else if (type == "add") {
                this.addModal = true
            }
        },
        async handleDelete(ids) {
            let params = qs.stringify({ idList: ids })
            let res = await this.$post(delEstatePrint, params, {
                "Content-Type": "application/x-www-form-urlencoded",
            });
            if (res.isSucceed) {
                this.$Message.success("删除成功");
                this.loadData();
            }
        },
        handleSelect(selection) {
            this.selectedList = selection.map(item => item.id)
        },
        pageChange(val) {
            this.pageNum = val;
            this.loadData();
        },
        async loadData() {
            this.isLoading = true;
            try {
                let res = await this.$get(estatePrintList, {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    ...this.query,
                });

                this.tableData = res.rows
            } finally {
                this.isLoading = false;
            }
        },
        async save() {
            this.modal_loading = true
            let res = await this.$post(saveEstatePrint, this.saveObj)
            if (res.isSucceed) {
                this.addModal = false
                this.$Message.success('保存成功');
                this.$refs.save.resetFields();
                this.saveObj.projectNO = ""
                this.loadData();
            } else {
                this.$Message.error('保存失败');
            }
            this.modal_loading = false
        },
        async saveBatch() {
            this.modal_loading = true
            let res = await this.$post(saveBatchEstatePrint, this.saveBatchObj)
            if (res.isSucceed) {
                this.addBatchModal = false
                this.$Message.success('保存成功');
                this.$refs.save.resetFields();
                this.saveBatchObj.projectNO = ""
                this.loadData();
            } else {
                this.$Message.error('保存失败');
            }
            this.modal_loading = false
        },
        async getProjectList() {
            let params = qs.stringify({
                page: 1,
                rows: 1000000,
                communityId: 0
            })
            let res = await this.$post(estateProjectList, params, {
                "Content-Type": "application/x-www-form-urlencoded",
            })
            this.projects = res.rows
        },
        projectChange(item) {
            if (item) {
                this.saveObj.projectNO = item.value
                this.saveObj.projectName = item.label
            }
        },
        projectBatchChange(item){
            if (item) {
                this.saveBatchObj.projectNO = item.value
                this.saveBatchObj.projectName = item.label
            }
        }
    },
    created() {
        this.loadData();
        this.getProjectList()
        console.log(this.$route);
    },
}
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}

.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}

.table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);

    .page {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }

    .action {
        color: #5e6d94;
        cursor: pointer;
        margin-right: 10px;
    }
}
</style>